import { RepositoryFactory } from '@/repositories/RepositoryFactory';

export default (_, inject) => {
  const repositories = (name) => {
    return RepositoryFactory.get(name);
  };
  inject('repositories', repositories);
};
